import { Outlet, useLocation } from 'react-router-dom';
import { QuestGlitchProvider, useQuestGlitch } from './QuestGlitchContext';
import { SiteHeader } from './components/SiteHeader';
import { getQuestPageConfig } from './questPages';

function LayoutContent() {
  const location = useLocation();
  const { isGlitching, glitchStyle } = useQuestGlitch();
  const questConfig = getQuestPageConfig(location.pathname);
  const showHeader = questConfig ? questConfig.showHeader : true;
  const showFooter = questConfig ? questConfig.showFooter : true;

  return (
    <div className={`page${isGlitching ? ' page--glitch' : ''}`} style={isGlitching ? glitchStyle : undefined}>
      {showHeader && <SiteHeader />}
      <Outlet />
      {showFooter && (
        <footer className="site-footer">
          <p>Virginie &amp; Jean-Christophe — 18 juillet 2026</p>
        </footer>
      )}
    </div>
  );
}

export function Layout() {
  return (
    <QuestGlitchProvider>
      <LayoutContent />
    </QuestGlitchProvider>
  );
}
